import { ChangeDetectionStrategy, Component, inject, InjectionToken } from '@angular/core';
import { MatButton } from '@angular/material/button';

export interface ActionNotificationData {
  message: string;
  action: string;
  onAction: () => void;
}

export const ACTION_NOTIFICATION_DATA = new InjectionToken<ActionNotificationData>('ACTION_NOTIFICATION_DATA');

@Component({
  selector: 'rms-action-notification',
  imports: [MatButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="flex items-center gap-4 rounded p-2 pl-4 shadow-lg bg-ruber text-flavius"
      role="alert"
      aria-live="assertive">
      <span>{{ data.message }}</span>
      <button
        mat-stroked-button
        type="button"
        class="text-flavius"
        (click)="data.onAction()">
        {{ data.action }}
      </button>
    </div>
  `,
})
export class ActionNotificationComponent {
  protected readonly data = inject(ACTION_NOTIFICATION_DATA);
}
